export const XME_ORIGIN = 'xref_enterprise';
export type XmeOriginState = 'requested';

/** Mark the profile URL as opened from Enterprise. */
export function appendXmeOrigin(url: string, state?: XmeOriginState): string {
  const parsed = new URL(url);
  parsed.searchParams.set('xme_origin', XME_ORIGIN);
  if (state) {
    parsed.searchParams.set('xme_state', state);
  } else {
    parsed.searchParams.delete('xme_state');
  }
  return parsed.toString();
}
